import { faTelegram } from "@fortawesome/free-brands-svg-icons";
import { LinkContent } from "../../../LinkDataInterface";
import {
  faCompassDrafting,
  faChampagneGlasses,
  faCalendar,
  faPeopleRoof,
  faUsersRectangle,
  faVestPatches,
  faPlaneDeparture,
  faBuildingColumns,
  faMicrophone,
  faSignHanging,
  faScaleBalanced,
  faMessage,
  faSackDollar,
  faMoneyBillTransfer,
  faThumbsUp,
  faGavel,
  faRectangleAd,
} from "@fortawesome/free-solid-svg-icons";

/* Edition 2027 */

/**** Documents généraux ****/
// Ordre du jour
export const odjPleniaire: LinkContent = {
  faLogo: faUsersRectangle,
  title: "OdJ Pléniaire 2027",
  link: "https://docs.google.com/document/d/1pfMoXeLLPAnkn8DOPogjxrsIQ_GYT91CGXrx4QJJVK4/",
};
export const odjTech: LinkContent = {
  faLogo: faVestPatches,
  title: "OdJ Technique 2027",
  link: "https://docs.google.com/document/d/1ktCdiZjrJwKzdDHxXnlWzYDp_TaZAa5Qqq270mith2I",
};
export const odjAnim: LinkContent = {
  faLogo: faPlaneDeparture,
  title: "OdJ Animation 2027",
  link: "https://docs.google.com/document/d/1Pob_ZlIuqLYmoXGBKFk5-pz3ajDBjufb9-4v-_DC8HM/",
};
export const odjPres: LinkContent = {
  faLogo: faBuildingColumns,
  title: "OdJ Présidence 2027",
  link: "https://docs.google.com/document/d/1d3daeKCA7h_KpQ38TVS0T3_2pGot0kYpyKFTD6XEdvo",
};
export const odjPromo: LinkContent = {
  faLogo: faMicrophone,
  title: "OdJ Promotion 2027",
  link: "https://docs.google.com/document/d/1UPGQU3jhoJ7a91zgFYjR7VhChq00aTm3Xc0fB3wzTRY",
};

// Documents communs
export const listComity: LinkContent = {
  faLogo: faPeopleRoof,
  title: "Liste comité 2027",
  link: "https://docs.google.com/spreadsheets/d/1EByu_oY3wBFDlLfJthD9oOZ_K_wBZ7X2wUNZRQYkV08",
};

export const listTelegram: LinkContent = {
  faLogo: faTelegram,
  title: "Liste groupes Telegram 2027",
  link: "https://docs.google.com/document/d/1T8zU2IvqvVq7CfzfqFdWcDt0L90wslrRy3libOjplwU",
};

/**** Animations ****/
export const suiviAnim: LinkContent = {
  faLogo: faChampagneGlasses,
  title: "Suivit anim 2027",
  link: "https://docs.google.com/spreadsheets/d/1v6QTPmOvKdsmeyHnnolIpfLmYbalHAW0g7uAlr_BExE/",
};
export const planningParSalle: LinkContent = {
  faLogo: faCalendar,
  title: "(PROV) Planning par salle 2027",
  link: "",
};

/**** Technique ****/
export const besoinTech: LinkContent = {
  faLogo: faCompassDrafting,
  title: "(PROV) Besoin tech 2027",
  link: "",
};
export const deadlineTech: LinkContent = {
  faLogo: faSignHanging,
  title: "(PROV) Deadlines Tech 2027",
  link: "",
};

/**** Promotion ****/
export const planningPublication: LinkContent = {
  faLogo: faMessage,
  title: "(PROV) Planning publication 2027",
  link: "",
};

export const textesPublication: LinkContent = {
  faLogo: faRectangleAd,
  title: "Textes promotion 2027",
  link: "https://docs.google.com/document/d/16z8LlnjwFMWhbhQlBlCa1_miDnizNWonl2ue_Hnv3ZE",
};

/**** Présidence ****/
export const budget: LinkContent = {
  faLogo: faScaleBalanced,
  title: "Budget 2027",
  link: "https://docs.google.com/spreadsheets/d/1Obf6Ob9ZkHO0eyAZNumr4ZEL00mX2Y3SiOtDsdCH81c",
};
export const dossierTresorerie: LinkContent = {
  faLogo: faSackDollar,
  title: "Trésorerie 2026 (dossier)",
  link: "https://drive.google.com/drive/folders/191_TXhvYQ7bd07aLEjVG9Lvza5ugcekV",
};
export const suiviPaiements: LinkContent = {
  faLogo: faMoneyBillTransfer,
  title: "Suivit des paiements",
  link: "https://docs.google.com/spreadsheets/d/1lNGQLPZCnjutGIuZ2GChK-IKTkWlbFWrCe5JPIZWyiA",
};
export const ag: LinkContent = {
  faLogo: faThumbsUp,
  title: "AG (dossier)",
  link: "https://drive.google.com/drive/folders/1yth2SmeSx7W6wB7uteLyjAdYMlIvkSVq",
};

export const status: LinkContent = {
  faLogo: faGavel,
  title: "Status et réglements (dossier)",
  link: "https://drive.google.com/drive/folders/15rZ4heCx4Oyy2PID9BwyAnOoNZdeZftb",
};
